import React from "react";

import { FaRegEye } from "react-icons/fa";
import { Whisper, Tooltip } from "rsuite";
import dayjs from "dayjs";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useState, useMemo, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CustomHeader from "./Utility/CustomHeader";
import PrescriptionModal from "./ClinicModal/PrescriptionModal";
ModuleRegistry.registerModules([AllCommunityModule]);

function UpcomingAppointmentsTable() {
  const [modalShow, setModalShow] = React.useState(false);
  const handleClose = () => setModalShow(false);
  const handleOpen = () => setModalShow(true);
  const tableStyle = `

  .btn-IdWmkZEQJd {
  border: none;
    background: #dcf2ff;
    color: #035ecf;
    width: 2.4rem;
    height: 2.4rem;
    display: flex
;
    align-items: center;
    justify-content: center;
    border-radius: .245rem;
    padding: .25rem .5rem;
  }


.ag-horizontal-right-spacer.ag-scroller-corner {
    display: none !important;
}

.ag-header-viewport {
  overflow-x: hidden !important;
  will-change: auto !important;
}

/* Soothing green strip for selected row */
.ag-theme-quartz .ag-row-selected::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #77c658; /* strip stays green */
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  z-index: 1;
}

.ag-cell-value{
  border-left: unset !important;
  border-right: 1px solid #e5e5e5 !important;
}

.ag-column-first{
  border: unset !important;
}

.ag-theme-quartz .ag-row-selected::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #77c658; /* strip stays green */
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  z-index: 1;
}

/* Override hover background for selected rows */
.ag-theme-quartz .ag-row-hover .ag-row-selected:hover {
  background-color: #f4fbf1 !important; /* same as selected */
}

.ag-checkbox-input-wrapper::before{
  display: none;
}

.ag-checkbox-input-wrapper::after{
  display: none;
}

  .ag-ltr .ag-sort-indicator-icon {
    padding-left: var(--ag-grid-size);
    display: none;
}

  .ag-header, .ag-advanced-filter-header {
    // background-color: #ff525a;
      background-color: #203342;
    border-bottom: var(--ag-borders-critical) var(--ag-border-color);
}

            .ag-full-width-container{
            height : 100% !important;
          }


         

  
        .ag-header-cell-text {
        font-size: 0.9rem;
      text-transform: uppercase;
      color: #1e374f;
      font-weight: 600;
      font-family: 'Nunito', sans-serif !important;

        }

              .ag-header-cell-resize::after{
                      background-color: #1991eb52;
                  }


            .ag-theme-quartz{
            padding: 0.4rem;
            }

              .ag-ltr .ag-cell{

                      text-align: center;
                      display: flex;
                      // justify-content: center;
                      align-items: center;
              }

              .ag-header{
                  // background-color: #edeff6;
                   border: none;
                  padding: 0.5rem 0;

                  min-height: 44px !important;
              }

              .ag-row {
               border: 1px solid #eeedf0;

              }

                  .ag-row-odd {
    background-color: #fff !important; /* Light gray */
  }

                    .ag-row-even {
    background-color: #f7f7f7 !important; /* Light gray */
  }






              .ag-root-wrapper{
                border: unset;
                background: transparent
              }

              .ag-body-viewport{
                border: 1px solid #8080801a;
                border-top-left-radius: 5px !important;
                border-top-right-radius: 5px !important;
                background-color: white;
              }

              .ag-theme-quartz .ag-header-cell-filter-button{
              display: none;}

.ag-header-cell-resize:after {
    background-color: #1991eb52;
    content: "";
    display: block;
    height: 30%;
    position: absolute;
    top: calc(50% - 30% * .5);2px;
    z-index: 1;
}

               .ag-cell, .ag-cell-not-inline-editing, .ag-cell-normal-height, .ag-cell-value, .ag-cell-focus{
                  font-size: .9rem;
               }

        .ag-body-vertical-scroll{
            display : none;
          }

    .ag-header-cell-sortable .ag-header-cell-label{
           justify-content: start;
        }
        
        .ag-ltr .ag-cell {
            font-weight: 500 !important;
            letter-spacing: 0.5px;
            color: #2b2b2b !important;
        }


          .odd-row {
          background-color: #f8f8fc;
        }
        
        .span-saceuu7u7{
            font-size: 13px; 
            background-color: #FAAB3C; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .span-jkmkmkmkm{
            font-size: 10px; 
            color: #6941C6 ;
            border: solid .1px #6941C6; 
            background-color: #F9F5FF; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            width: 7rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .span-jkmkmkmkmjbui{
            font-size: 10px; 
            color: #175CD3 ;
            border: solid .1px #B2DDFF; 
            background-color: #EFF8FF; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            width: 7rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
                .ag-header-cell-label{
        display: flex;
        justify-content: center;
        }

        
  
  `;
  const navigate = useNavigate();

  const getStableColor = (key) => {
    const bgColors = [
      "bg-danger bg-opacity-50",
      "bg-success bg-opacity-50",
      "bg-primary bg-opacity-50",
      "bg-warning bg-opacity-50",
      "bg-secondary bg-opacity-50",
      "bg-danger bg-opacity-50",
      "bg-primary bg-opacity-50",
      "bg-info bg-opacity-50",
      "bg-warning bg-opacity-50",
      "bg-success bg-opacity-50",
      "bg-info bg-opacity-10",
      "bg-success bg-opacity-50",
      "bg-danger bg-opacity-50",
      "bg-danger bg-opacity-50",
      "bg-secondary bg-opacity-50",
    ];

    let hash = 0;
    for (let i = 0; i < key.length; i++) {
      hash = key.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % bgColors.length;
    return bgColors[index];
  };

  const [rowData, setRowData] = useState([
    {
      "Appointment ID": "AP0001",
      "Patient Name": "Janu",
      "Time Slot": "3:00 pm",
      "Visit Type": "In-person",
      "Doctor": "DR. Rohan",
      "Reason for Visit": "General Checkup",
      "Appointment Date": "03-01-2025",
      "Assigned Room": "03",
      "Reminder Status": "Reminder Sent"
    },
    {
      "Appointment ID": "AP0002",
      "Patient Name": "Lokesh",
      "Time Slot": "10:00 am",
      "Visit Type": "Virtual",
      "Doctor": "DR. Samantha ",
      "Reason for Visit": "Follow-up",
      "Appointment Date": "03-02-2025",
      "Assigned Room": "N/A",
      "Reminder Status": "Reminder Pending"
    },
    {
      "Appointment ID": "AP0003",
      "Patient Name": "Kameswari",
      "Time Slot": "2:30 pm",
      "Visit Type": "In-person",
      "Doctor": "DR. Sanjay",
      "Reason for Visit": "General Checkup",
      "Appointment Date": "03-01-2025",
      "Assigned Room": "05",
      "Reminder Status": "Reminder Sent"
    },
    {
      "Appointment ID": "AP0004",
      "Patient Name": "Revathi",
      "Time Slot": "11:15 am",
      "Visit Type": "Virtual",
      "Doctor": "DR. Sita",
      "Reason for Visit": "Diagnosis",
      "Appointment Date": "03-03-2025",
      "Assigned Room": "N/A",
      "Reminder Status": "Reminder Pending"
    },
    {
      "Appointment ID": "AP0005",
      "Patient Name": "Lakshmi",
      "Time Slot": "4:45 pm",
      "Visit Type": "In-person",
      "Doctor": "DR. Samantha ",
      "Reason for Visit": "General Checkup",
      "Appointment Date": "03-01-2025",
      "Assigned Room": "06",
      "Reminder Status": "Reminder Sent"
    },
    {
      "Appointment ID": "AP0006",
      "Patient Name": "Sudhakar",
      "Time Slot": "1:00 pm",
      "Visit Type": "Virtual",
      "Doctor": "DR. Lakshmi",
      "Reason for Visit": "Follow-up",
      "Appointment Date": "03-02-2025",
      "Assigned Room": "N/A",
      "Reminder Status": "Reminder Pending"
    },
    {
      "Appointment ID": "AP0007",
      "Patient Name": "Anuradha",
      "Time Slot": "3:30 pm",
      "Visit Type": "In-person",
      "Doctor": "DR. Syam",
      "Reason for Visit": "Diagnosis",
      "Appointment Date": "03-01-2025",
      "Assigned Room": "07",
      "Reminder Status": "Reminder Sent"
    },
    {
      "Appointment ID": "AP0008",
      "Patient Name": "Ritish",
      "Time Slot": "9:00 am",
      "Visit Type": "Virtual",
      "Doctor": "DR. Vishnavi",
      "Reason for Visit": "Follow-up",
      "Appointment Date": "03-03-2025",
      "Assigned Room": "N/A",
      "Reminder Status": "Reminder Pending"
    },
    {
      "Appointment ID": "AP0009",
      "Patient Name": "Shivam",
      "Time Slot": "12:30 pm",
      "Visit Type": "In-person",
      "Doctor": "DR. Priya",
      "Reason for Visit": "General Checkup",
      "Appointment Date": "03-01-2025",
      "Assigned Room": "04",
      "Reminder Status": "Reminder Sent"
    },
    {
      "Appointment ID": "AP0010",
      "Patient Name": "Hema",
      "Time Slot": "5:15 pm",
      "Visit Type": "Virtual",
      "Doctor": "DR. Ravindra",
      "Reason for Visit": "Diagnosis",
      "Appointment Date": "03-03-2025",
      "Assigned Room": "N/A",
      "Reminder Status": "Reminder Pending"
    },
    {
      "Appointment ID": "AP0011",
      "Patient Name": "Raju",
      "Time Slot": "8:45 am",
      "Visit Type": "In-person",
      "Doctor": "DR. Sravani",
      "Reason for Visit": "Follow-up",
      "Appointment Date": "03-01-2025",
      "Assigned Room": "02",
      "Reminder Status": "Reminder Sent"
    }
  ]);
  const [colDefs, setColDef] = useState([
    {
      headerName: "Appointment ID",
      field: "Appointment ID",
      minWidth: 150,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => (
        <span className="text-secondary fw-medium small">{params.value}</span>
      ),
    },

    {
      headerName: "Patient Name",
      field: "Patient Name",
      width: 170,
      minWidth: 170,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: function (params) {
        const name = params.value || "U";
        const initial = name.charAt(0).toUpperCase();
        const bgColor = getStableColor(name);

        return (
          <div className="d-flex align-items-center gap-2">
            <div
              className={`d-flex justify-content-center align-items-center rounded-circle text-white fw-bold ${bgColor}`}
              style={{ width: "2rem", height: "2rem", fontSize: "0.875rem" }}
            >
              {initial}
            </div>
            <span className="fw-bold text-secondary small">{name}</span>
          </div>
        );
      },
    },

    {
      headerName: "Time Slot",
      field: "Time Slot",
      minWidth: 120,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => (
        <span className="text-secondary fw-medium small">{params.value}</span>
      ),
    },

    {
      headerName: "Doctor",
      field: "Doctor",
      minWidth: 150,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => (
        <span className="text-secondary fw-medium small">{params.value}</span>
      ),
    },

    {
      headerName: "Reason for Visit",
      field: "Reason for Visit",
      minWidth: 180,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellStyle: {
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
      },
      cellRenderer: (params) => {
        let borderColor = "border border-secondary";
        let bgColor = "bg-light";
        let textColor = "text-secondary";
        let dotColor = "bg-secondary";

        switch (params.value) {
          case "General Checkup":
            borderColor = "border border-success";
            bgColor = "bg-success bg-opacity-10";
            textColor = "text-success";
            dotColor = "bg-success";
            break;
          case "Follow-up":
            borderColor = "border border-warning"; 
            bgColor = "bg-gray-100"; 
            textColor = "text-warning"; 
            dotColor = "bg-warning";
            break;
          case "Diagnosis":
            borderColor = "border border-info"; 
            bgColor = "bg-gray-100"; 
            textColor = "text-info"; 
            dotColor = "bg-info";
            break;
        }

        return (
          <div
            className={`d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill fw-semibold small ${bgColor} ${textColor} ${borderColor}`}
            style={{ fontSize: "12px", lineHeight: "1rem" }}
          >
            <span
              className={`rounded-circle ${dotColor}`}
              style={{ width: "8px", height: "8px" }}
            ></span>
            {params.value}
          </div>
        );
      },
    },

    {
      headerName: "Appointment Date",
      field: "Appointment Date",
      minWidth: 150,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: function (params) {
          
              const formattedDate = dayjs(params.value)
                .format("DD-MMM-YYYY")
                .replace(
                  /-(\w{3})-/,
                  (_, month) =>
                    `-${month.charAt(0).toUpperCase()}${month
                      .slice(1)
                      .toLowerCase()}-`
                );
              return (
                <>
                  <span className="text-secondary fw-medium small">
                    {formattedDate}
                  </span>
                </>
              );
            },
    },

    

    {
      headerName: "Assigned Room",
      field: "Assigned Room",
      minWidth: 110,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => (
        <span className="text-secondary fw-medium small">{params.value}</span>
      ),
    },

    {
      headerName: "Reminder Status",
      field: "Reminder Status",
      minWidth: 180,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellStyle: {
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
      },
      cellRenderer: (params) => {
        let borderColor = "border border-secondary";
        let bgColor = "bg-light";
        let textColor = "text-secondary";
        let dotColor = "bg-secondary";

        switch (params.value) {
          case "Reminder Sent":
            borderColor = "border border-success";
            bgColor = "bg-success bg-opacity-10";
            textColor = "text-success";
            dotColor = "bg-success";
            break;
          case "Reminder Pending":
            borderColor = "border border-warning";
            bgColor = "bg-gray-100";
            textColor = "text-warning";
            dotColor = "bg-warning";
            break;
        }

        return (
          <div
            className={`d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill fw-semibold small ${bgColor} ${textColor} ${borderColor}`}
            style={{ fontSize: "12px", lineHeight: "1rem" }}
          >
            <span
              className={`rounded-circle ${dotColor}`}
              style={{ width: "8px", height: "8px" }}
            ></span>
            {params.value}
          </div>
        );
      },
    },

  ]);

  const autoSizeStrategy = {
    type: "fitGridWidth",
    columnLimits: [
      {
        colId: "No of Team Members",
        minWidth: 900,
      },
    ],
  };

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      filter: true,
      sortable: true,
      enableRowGroup: true,
      sort: "asc",
      resizable: true,
      headerComponent: CustomHeader,
    };
  }, []);

  const rowSelection = {
    mode: "multiRow",
    headerCheckbox: true,
  };

  return (
    <div style={{ width: "100%", height: "454px" }}>

      {/* Grid wrapper */}
      <div
    id="grid-wrapper"
    className="ag-theme-quartz custom-ag-grid"
    style={{
      width: "100%",
      height: "454px",
      backgroundColor: "#fff",
      minHeight: "32rem",
    }}
      >
        <style>{tableStyle}</style>
        <AgGridReact
          rowData={rowData}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          pagination={false}
          rowClass="tbl-row-sc"
          rowHeight={40}
          headerHeight={30}
          autoSizeStrategy={autoSizeStrategy}
          rowSelection={rowSelection}
        />
      </div>
    </div>
  );
}

export default UpcomingAppointmentsTable;
